import type { AccessToken } from './tokenSlice.ts';

export interface StorageUtil {
    discardAccessToken: () => void;
    getAccessToken: () => AccessToken;
    hasAccessToken: () => boolean;
    saveAccessToken: (token: AccessToken) => void;
}

export const configureStorage = (): StorageUtil => {
    let storedAccessToken: string | null = null;
    return {
        discardAccessToken: () => {
            storedAccessToken = null;
        },
        getAccessToken: () => storedAccessToken,
        hasAccessToken: () => Boolean(storedAccessToken),
        saveAccessToken: (token: AccessToken) => {
            if (token) {
                storedAccessToken = token;
            }
        },
    };
};

export const configureAccessToken = (storage: StorageUtil) => {
    return storage;
};

export const accessToken = configureAccessToken(configureStorage());
